import { Button } from '../ui/button';
import { Dialog, DialogClose, DialogContent, DialogTrigger } from '../ui/dialog';
import ArrowExpand from '@/assets/icons/arrow_expand.svg?react';
import ArrowCollapse from '@/assets/icons/arrow_collapse.svg?react';
import FullJar from '@/assets/icons/full_jar.svg?react';
import { components } from '@/types/api';
import MarkdownRenderer from '@/components/ui/MarkdownRenderer';

export function LoyalityRulesModal({
  account,
  isOpen,
  setIsRulesModalOpen,
}: {
  account: components['schemas']['AccountDetailsOutput'];
  isOpen: boolean;
  setIsRulesModalOpen: (val: boolean) => void;
}) {
  return (
    <Dialog open={isOpen} onOpenChange={setIsRulesModalOpen}>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-0 right-0"
          onClick={() => setIsRulesModalOpen(!isOpen)}
        >
          <ArrowExpand />
        </Button>
      </DialogTrigger>
      <DialogContent className="h-screen min-w-full overflow-y-auto rounded-none" hideCloseButton>
        <div className="flex flex-col gap-4">
          <div className="flex justify-end">
            <DialogClose asChild>
              <Button variant="ghost" size="icon" className="absolute top-2 right-1">
                <ArrowCollapse />
              </Button>
            </DialogClose>
          </div>
          <span className="relative min-h-96">
            <span className="text-foreground text-3xl leading-normal font-bold">
              You have&nbsp;
              <br className="block md:hidden" />
              earned
              <br />
              <span className="text-primary">{account.loyalty_earned} points</span>
            </span>
            <FullJar className="absolute top-0 -right-6" />
          </span>
          <MarkdownRenderer content={account.long_description || ''} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
